module.exports = __webpack_public_path__ + "static/media/jason.ae034cf5.jpg";